export default __webpack_public_path__ + "static/media/finsight_logo_transparent.14768239.png";